// eslint-disable-next-line no-use-before-define
import React from 'react';
import { logoCoraBase64 } from '../../../../../assets/base64/cora-logo';
export const Logo = () => {
    return (React.createElement("div", { className: 'main-menu_logo' },
        React.createElement("img", { alt: "Logo Cora", title: "Logo Cora", src: logoCoraBase64 })));
};
//# sourceMappingURL=logo.js.map